/**
 * Współdzielona konfiguracja i typy dla modułu dokumentów.
 * Plik zawiera enum typów dokumentów, interfejsy i konfigurację TinyMCE.
 */

export enum DocumentType {
  SALES_AGREEMENT = "sales-agreement",
  CERTIFICATE_OF_CONFORMITY = "certificate-of-conformity",
}

export const DOCUMENT_TYPE_LABELS: Record<DocumentType, string> = {
  [DocumentType.SALES_AGREEMENT]: "Umowa sprzedaży",
  [DocumentType.CERTIFICATE_OF_CONFORMITY]: "Świadectwo zgodności",
};

export interface Document {
  _id?: string;
  language: string;
  content: string;
  type: DocumentType;
}

export interface DocumentQuery {
  _id?: string;
  language?: string;
  type?: DocumentType;
}

export const DOCUMENT_TINY_MCE_CONFIG = {
  height: 460,
  menubar: "edit view insert format tools table help",
  plugins: "lists link table code wordcount autoresize paste",
  toolbar:
    "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | bullist numlist | link table | removeformat code",
  font_family_formats:
    "Arial=arial,helvetica,sans-serif; Calibri=calibri,sans-serif; Georgia=georgia,palatino,serif; Helvetica=helvetica,arial,sans-serif; Montserrat=montserrat,sans-serif; Roboto=roboto,sans-serif; Tahoma=tahoma,arial,helvetica,sans-serif; Times New Roman=times new roman,times,serif; Verdana=verdana,geneva,sans-serif",
  font_size_formats:
    "7px 9px 10px 10.5px 11px 12px 14px 16px 18px 20px 24px 28px 32px 36px",
  branding: false,
  promotion: false,
  statusbar: true,
  browser_spellcheck: true,
  autoresize_bottom_margin: 16,
  paste_as_text: false,
  content_style:
    "body { font-family: Helvetica,Arial,sans-serif; font-size:14px; line-height:1.5; } p { margin: 0 0 10px 0; }",
};

/**
 * Zwraca konfigurację TinyMCE dla danego typu dokumentu.
 * Dla CERTIFICATE_OF_CONFORMITY paragrafy mają margines 0.
 */
export function getTinyMceConfig(
  type: DocumentType,
): typeof DOCUMENT_TINY_MCE_CONFIG {
  const baseConfig = { ...DOCUMENT_TINY_MCE_CONFIG };

  if (type === DocumentType.CERTIFICATE_OF_CONFORMITY) {
    return {
      ...baseConfig,
      content_style:
        "body { font-family: Helvetica,Arial,sans-serif; font-size:14px; line-height:1.5; } p { margin: 0; } table td, table th { white-space: normal; overflow-wrap: anywhere; word-break: break-word; }",
    };
  }

  return baseConfig;
}
